import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProformsAdminService } from '../../../services/proforms/proforms-admin.service';

@Component({
  selector: 'app-proforms-question-answer-options-checkbox',
  standalone: false,
  templateUrl: './proforms-question-answer-options-checkbox.component.html',
  styleUrl: './proforms-question-answer-options-checkbox.component.scss',
})
export class ProformsQuestionAnswerOptionsCheckboxComponent
  implements OnChanges
{
  @Input() checkStatus: number;

  @Input() optionId: number;

  @Output() readonly answerClicked: EventEmitter<number> = new EventEmitter();

  localStatus: boolean;

  constructor(private proformsAdminService: ProformsAdminService) {}

  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'checkStatus':
          this.setLocalStatus();
          break;
        default:
      }
    });
  }

  setLocalStatus() {
    this.localStatus = this.checkStatus === 1;
  }

  handleQuizAnswer(event: Event) {
    const target = event.target as HTMLInputElement | null;
    let payload;
    if (target) {
      if (target.checked) {
        payload = {
          is_correct: 1,
        };
        this.answerClicked.emit(this.optionId);
      } else {
        payload = {
          is_correct: 0,
        };
      }
      this.proformsAdminService
        .updateCorrectAnswerOption(this.optionId, payload)
        .subscribe();
    }
  }
}
